import { render, staticRenderFns } from "./Spaceplans.vue?vue&type=template&id=798361ea&scoped=true&"
import script from "./Spaceplans.vue?vue&type=script&lang=js&"
export * from "./Spaceplans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798361ea",
  null
  
)

export default component.exports